"use client";

import { useEffect } from "react";

/**
 * Script Manager Component
 *
 * Handles the injection of the theme initialization and client-side chunk
 * error handling scripts without triggering React's "script tag while rendering"
 * warning in the App Router.
 */
export function ScriptManager() {
  useEffect(() => {
    // // // Theme initialization logic (removed - theme handled by CSS)

    // Chunk error handler
    const handleError = (event: ErrorEvent) => {
      if (
        event.message &&
        (event.message.includes("ChunkLoadError") ||
          event.message.includes("Loading chunk"))
      ) {
        console.error("Chunk loading error detected, reloading page");
        if (typeof caches !== "undefined") {
          caches.keys().then((names) => {
            for (const name of names) caches.delete(name);
          });
        }
        setTimeout(() => window.location.reload(), 1000);
        event.preventDefault();
      }
    };

    window.addEventListener("error", handleError);
    return () => window.removeEventListener("error", handleError);
  }, []);

  return null;
}
